<button mat-flat-button color="cancel" [disabled]="isDisabled$ | async" (click)="onClick()">
    {{ label }}
</button>
